import "../../../styles/Colors.css";
import "../../calendar/styles/CalendarStyle.css";
import "../../../styles/Fonts.css";
import { Link } from "react-router-dom";
import { useState } from "react";
import DateObject from "react-date-object";
import persian from "react-date-object/calendars/persian.js";
import persian_fa from "react-date-object/locales/persian_fa.js";

function DatePickerWeekly({
  week,
  setSelectedDate,
  setSelectedDateLabel,
  setShowDModal,
  setShowModal,
}) {
  const [style, setStyle] = useState({});

  const handleClick = (newValue) => {
    let allButtons = document.querySelectorAll(".far");

    allButtons.forEach((div) => {
      div.style.backgroundColor = "";
    });
    setSelectedDate(new Date(newValue.target.value));
    setSelectedDateLabel(
      new DateObject({
        date: new Date(newValue.target.value),
        locale: persian_fa,
      })
        .setCalendar(persian)
        .format("dddd DD MMMM")
    );
    newValue.target.style.backgroundColor = "yellow";
    setShowDModal(false);
    setShowModal(true);
  };

  return week.map((elem) => {
    let today = new DateObject({
      date: new Date(),
      locale: persian_fa,
    });

    let className;
    if (
      elem.setCalendar(persian).format("dddd DD MMMM") ===
      today.setCalendar(persian).format("dddd DD MMMM")
    ) {
      className =
        "far subject-1 grey-1 b-grey-4 paddingSide5 paddingUpDown1r width50 radius1 marginBottom3 today-date";
    } else {
      className =
        "far subject-1 grey-1 b-grey-4 paddingSide5 paddingUpDown1r width50 radius1 marginBottom3";
    }
    let val = new Date(elem.convert()).toISOString().substring(0, 10);

    return (
      <div className="centerAlign">
        <Link to="#" className="centerd">
          <button
            style={style}
            onClick={handleClick}
            value={val}
            className={className}
          >
            {elem.setCalendar(persian).format("dddd DD MMMM")}
          </button>
        </Link>
      </div>
    );
  });
}
export default DatePickerWeekly;
